// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>28</span>&nbsp;&nbsp;For your temple&#146;s sake in Jerusalem&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;kings shall bring their gifts to you.<br> </p> </div></div>";
// Exports
module.exports = code;